import dateField from "../../common/date-field";
import decimalField from "../../common/decimal-field.vue";
import { hasValue } from "../../../utils/functions.js";

export default {
  name: "transactions",
  components: {
    dateField,
    decimalField
  },
  data: function() {
    return {
      countFilter: 0,
      BankList: [],
      BankData: {
        Bank: {
          Code: null
        },
        AccountType: {
          Code: null
        },
        BankAgency: "",
        BankAgencyDigit: "",
        BankAccount: "",
        BankAccountDigit: ""
      },
      MerchantAuth: {
        MerchantType: {
          Code: null
        }
      },
      disabledDatesCreatedMax: new Date(),
      disabledDatesCreatedMin: new Date(),
      disabledDatesPaymentMax: new Date(),
      disabledDatesPaymentMin: new Date(),
      initialDate: new Date(),
      Columns: {
        Id: true,
        Customer: true,
        Reference: true,
        PaymentMethod: true,
        Application: true,
        Canal:true,
        Amount: true,
        Vendor: false,
        Status: true,
        PaymentDate: true,
        Subaccount: false,
        NomeCanal: true
      },
      labelIdentity: "CPF/CNPJ",
      labelName: "Cliente",
      loading: false,
      loadingCreateUpdate: false,
      loadingDownload: false,
      loadingTransaction: false,
      loadingReport: false,
      validatedBankData: false,
      loadingReportProfit: false,
      loadingResendEmail: false,
      loadingResendTechEmail: false,
      loadingContract: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      filter: {
        Id: null,
        CustomerName: null,
        CustomerIdentity: null,
        Reference: null,
        PaymentMethodCode: null,
        AmountInitial: null,
        AmountEnd: null,
        Vendor: null,
        Application: null,
        TransactionStatusCode: null,
        CreatedDateInitial: null,
        CreatedDateEnd: null,
        PaymentDateInitial: null,
        PaymentDateEnd: null,
        IdMerchantSubAccount: null,
        IdTransactionSplitter: null,
        IsSandbox: false,
        IdCanal: null
      },
      idtransactions: 0,
      transactions: [],
      pOpened: null,
      infoTransaction: {
        Id: 0,
        Reference: null,
        Vendor: null,
        Application: null,
        Customer: {
          Name: null,
          Identity: null,
          Email: null,
          Address: {
            ZipCode: null,
            Street: null,
            Number: null,
            District: null,
            Complement: null,
            City: {
              Name: null,
              Initials: null
            },
            State: {
              Initials: null
            }
          }
        },
        PaymentMethod: {
          Code: null,
          BankSlipNumber: null,
          DueDate: null,
          InstallmentQuantity: null
        },
        PaymentObject: {
          Symbol: null,
          Brand: {
            Code: null
          },
          Amount: null,
          Address: null,
          Provider: null,
          AdditionPayment: null,
          DiscountPayment: null,
          QrCode: null,
          BankData: {
            BankAgency: null,
            BankAgencyDigit: null,
            BankAccount: null,
            BankAccountDigit: null,
            Bank: {
              Name: null
            }
          },
          SoftDescriptor: null
        },
        Amount: null,
        PaymentDate: null,
        CreatedDate: null,
        CheckingAccounts: [],
        Splits: [],
        History: [],
        IsSplitter: false,
        Products: [],
        Plan: {
          Name: null
        },
        TransactionStatus: {
          Code: "1"
        }
      },
      isSeeing: false,
      modalTitle: "Novo cliente",
      mSteps: ["Cliente", "Pagamento", "Produto", "Histórico de Status", "Splits", "Informações adicionais"],
      transactionStatus: [],
      idMerchant: null,
      paymentMethods: [],
      applications: [],
      vendors: [],
      subcontas: [],
      mCurrentStep: 0,
      previousPageinfo: [],
      redirectOpen: false,
      tableKey: 0,
      taxPaymentMethod: null,
      ticketsTableKey: 0,
      validatedCompanyStep: false,
      validatedResponsibleStep: false,
      validatedTaxForm: false,
      validatedTechStep: false,
      selected_payment: null,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  watch: {
    "pagination.PageNumber": function() {
      this.ListTransaction(this.idMerchant);
    },
    "pagination.RowsPerPage": function() {
      this.ListTransaction(this.idMerchant);
    },
    "filter.CreatedDateInitial": function() {
      this.disabledDatesCreatedMax = new Date();
      this.disabledDatesCreatedMin = this.filter.CreatedDateInitial;
      this.$bvModal.hide("mFilter");
      this.$bvModal.show("mFilter");
    },
    "filter.PaymentDateInitial": function() {
      this.disabledDatesPaymentMax = new Date();
      this.disabledDatesPaymentMin = this.filter.PaymentDateInitial;
      this.$bvModal.hide("mFilter");
      this.$bvModal.show("mFilter");
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.idMerchant = this.$route.params.idMerchant;
    this.GetMerchant(this.idMerchant);

    this.ListTransactionStatus();
    this.ListPaymentMethod();
    this.ListApplications(this.idMerchant);
    this.ListVendors(this.idMerchant);
    this.GetClass();
    this.GetBanks();
    let columns = sessionStorage.getItem("Columns");

     //Oculta tooltip de estorno para transações online
    this.$root.$emit('bv::disable::tooltip', 'tooltipCanal2Estorno');

    if (columns != null) this.Columns = JSON.parse(columns);
    this.ListTransaction(this.idMerchant);
  },
  methods: {
    GetBanks: function() {
      this.$store
        .dispatch("GetBanks")
        .then(response => {
          this.BankList = response;
        })
        .catch(error => {
          this.$makeToast(
            "Não foi possível carregar a lista de bancos, tente novamente.",
            "danger",
            "Falha ao obter a lista de bancos",
            error
          );
        });
    },
    OpenModalCancelBankSlip: function(i) {
      this.ResetInfoBankData();
      this.idTransaction = this.transactions[i].Id;

      this.$bvModal.show("mFormCancelBankSlip");
    },
    OpenWriteOffBankSlip: function(i) {
      this.pOpened = i;
      this.idTransaction = this.transactions[i].Id;
      this.$makeMsgBox(`Deseja cancelar este boleto?`, "Confirmar ação", this.WriteOffBankSlip);
    },
    WriteOffBankSlip: function() {
      this.$store
        .dispatch("WriteOffBankSlip", {
          idTransaction: this.idTransaction,
          idMerchant: this.idMerchant
        })
        .then(response => {
          if (response) {
            this.ListTransaction(this.idMerchant);

            this.$makeToast(`O cancelamento do boleto foi solicitado`, "success", `Transação ${this.idTransaction}`);
          } else {
            this.$makeToast(undefined, "danger", "Erro ao solicitar baixa", error);
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao solicitar baixa", error);
        });
    },
    OpenCancelCreditCard: function(i) {
      this.pOpened = i;
      this.idTransaction = this.transactions[i].Id;

      this.$makeMsgBox(`Deseja estornar este pagamento?`, "Confirmar ação", this.CancelCreditCard);
    },
    CancelCreditCard: function() {
      this.$store
        .dispatch("CancelCreditCard", {
          idTransaction: this.idTransaction,
          idMerchant: this.idMerchant
        })
        .then(response => {
          if (response.isCancelled) {
            this.ListTransaction(this.idMerchant);

            this.$makeToast(`Estorno efetuado com sucesso`, "success", `Transação ${this.idTransaction}`);
          } else {
            this.$makeToast(response.Message || "Não foi possível efetuar o estorno.", "danger", `Transação ${this.idTransaction}`);
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao estornar", error);
        });
    },
    CancelBankSlip: function() {
      this.loadingCreateUpdate = true;
      this.$store
        .dispatch("CancelBankSlip", {
          idTransaction: this.idTransaction,
          idMerchant: this.idMerchant,
          BankData: this.BankData
        })
        .then(response => {
          if (response.isCancelled) {
            this.$bvModal.hide("mFormCancelBankSlip");
            this.ListTransaction(this.idMerchant);
            this.$makeToast(`Estorno efetuado com sucesso`, "success", `Transação ${this.idTransaction}`);
          } else {
            this.$makeToast(undefined, "danger", `${response.Message}`, error);
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao estornar", error);
        })
        .finally(() => {
          this.loadingCreateUpdate = false;
        });
    },
    OpenCancelPix: function(i) {
      this.pOpened = i;
      this.idTransaction = this.transactions[i].Id;

      if (this.transactions[i].TransactionStatus && this.transactions[i].TransactionStatus.Code == "19") {
        this.$makeToast("Atenção", "warning", "A devolução deste Pix já está em processamento. Aguarde a conclusão.");
        return;
      }

      this.$makeMsgBox(`Deseja estornar este pagamento?`, "Confirmar ação", this.CancelPix);
    },
    CancelPix: function() {
      this.$store
        .dispatch("CancelPix", {
          idTransaction: this.idTransaction,
          idMerchant: this.idMerchant
        })
        .then(response => {
          const detail = response;

          this.ListTransaction(this.idMerchant);

          if (detail.isCancelled) {
            this.$makeToast(`Estorno efetuado com sucesso`, "success", `Transação ${this.idTransaction}`);
          } else {
            this.$makeToast("Devolução em processamento", "info", `${detail.Message}`);
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao estornar", error);
        });
    },
    ListSubaccount: function(idMerchant) {
      this.$store
        .dispatch("ListSubaccount", { idMerchant: idMerchant })
        .then(response => {
          this.subcontas = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de subcontas", error);
        });
    },
    GetClass: function() {
      if (this.infoTransaction != null && this.infoTransaction.Id > 0) {
        switch (this.infoTransaction.TransactionStatus.Code) {
          case "1":
            return "labelModal labelsecondary";
          case "2":
          case "5":
          case "6":
          case "12":
          case "19":
            return "labelModal labelwarning";
          case "11":
          case "14":
            return "labelModal labelinfo";
          case "3":
            return "labelModal labelsuccess";
          case "4":
            break;
          case "7":
          case "8":
          case "13":
            return " labelModal labeldanger";
        }
      }
    },
    GetMerchant: function(id) {
      this.loadingMerchant = true;
      this.$store
        .dispatch("GetMerchant", { id: id })
        .then(response => {
          this.MerchantAuth = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações da empresa", error);
        })
        .finally(() => {
          this.loadingMerchant = false;
        });
    },
    OpenModalTransaction: function(i) {
      this.mCurrentStep = 0;
      this.ResetinfoTransaction();

      // View
      this.pOpened = i;
      this.idTransaction = this.transactions[i].Id;
      this.isSeeing = true;
      this.modalTitle = "Detalhes da transação";
      this.GetTransaction(this.idTransaction);
      this.$bvModal.show("mFormTransaction");
    },
    ColumnsConfigChanged: function() {
      sessionStorage.setItem("Columns", JSON.stringify(this.Columns));
    },
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListTransaction(this.idMerchant);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ListTransaction: function(idMerchant) {
      this.countFilter = 0;
      if (hasValue(this.filter.Id)) this.countFilter++;
      if (hasValue(this.filter.CustomerName)) this.countFilter++;
      if (hasValue(this.filter.CustomerIdentity)) this.countFilter++;
      if (hasValue(this.filter.Reference)) this.countFilter++;
      if (hasValue(this.filter.PaymentMethodCode)) this.countFilter++;
      if (hasValue(this.filter.Application)) this.countFilter++;
      if (hasValue(this.filter.AmountInitial)) this.countFilter++;
      if (hasValue(this.filter.AmountEnd)) this.countFilter++;
      if (hasValue(this.filter.Vendor)) this.countFilter++;
      if (hasValue(this.filter.TransactionStatusCode)) this.countFilter++;
      if (hasValue(this.filter.CreatedDateInitial)) this.countFilter++;
      if (hasValue(this.filter.CreatedDateEnd)) this.countFilter++;
      if (hasValue(this.filter.PaymentDateInitial)) this.countFilter++;
      if (hasValue(this.filter.PaymentDateEnd)) this.countFilter++;
      if (hasValue(this.filter.IsSandbox)) this.countFilter++;
      if (hasValue(this.filter.IdCanal)) this.countFilter++;

      this.loading = true;
      let params = this.GetParamsData(idMerchant);
      this.$store
        .dispatch("ListTransactions", { params: params })
        .then(response => {
          this.transactions = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar as transações", error);
        })
        .finally(() => (this.loading = false));
    },
    GetParamsData: function(idMerchant, deletePagination = false) {
      var columns = [];

      if (deletePagination)
        if (Object.keys(this.Columns).length > 0) {
          for (let key in this.Columns) {
            var keyValue = this.Columns[key];
            if (keyValue != null && keyValue != "undefined") {
              if (keyValue == true) columns.push(key);
            }
          }
        }

      let data = {
        ...this.pagination,
        CreatedDateInitial: this.filter.CreatedDateInitial,
        CreatedDateEnd: this.filter.CreatedDateEnd,
        PaymentDateInitial: this.filter.PaymentDateInitial,
        PaymentDateEnd: this.filter.PaymentDateEnd,
        AmountInitial: this.filter.AmountInitial,
        AmountEnd: this.filter.AmountEnd,
        IdTransactionSplitter: this.filter.IdTransactionSplitter,
        IdMerchantSubAccount: this.filter.IdMerchantSubAccount,
        ColumnsFilter: columns,
        "Object.Id": this.filter.Id,
        "Object.Merchant.Id": idMerchant,
        "Object.Reference": this.filter.Reference,
        "Object.Application": this.filter.Application,
        "Object.Vendor": this.filter.Vendor,
        "Object.IsSandbox": this.filter.IsSandbox,
        "Object.Customer.Name": this.filter.CustomerName,
        "Object.Customer.Identity": this.filter.CustomerIdentity,
        "Object.PaymentMethod.Code": this.filter.PaymentMethodCode,
        "Object.TransactionStatus.Code": this.filter.TransactionStatusCode,
        "IdCanal": this.filter.IdCanal,
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    ResetInfoBankData: function() {
      this.BankData = {
        Bank: {
          Code: null
        },
        AccountType: {
          Code: null
        },
        BankAgency: "",
        BankAgencyDigit: "",
        BankAccount: "",
        BankAccountDigit: ""
      };
    },
    ResetinfoTransaction: function() {
      this.mCurrentStep = 0;
      this.idTransaction = 0;
      this.infoTransaction = {
        Id: 0,
        Reference: null,
        Vendor: null,
        Application: null,
        Customer: {
          Name: null,
          Identity: null,
          Email: null,
          Address: {
            ZipCode: null,
            Street: null,
            Number: null,
            District: null,
            Complement: null,
            City: {
              Name: null,
              Initials: null
            },
            State: {
              Initials: null
            }
          }
        },
        PaymentMethod: {
          Code: null,
          BankSlipNumber: null,
          DueDate: null,
          InstallmentQuantity: null
        },
        PaymentObject: {
          Symbol: null,
          Brand: {
            Code: null
          },
          Amount: null,
          Address: null,
          Provider: null,
          AdditionPayment: null,
          DiscountPayment: null,
          QrCode: null,
          BankData: {
            BankAgency: null,
            BankAgencyDigit: null,
            BankAccount: null,
            BankAccountDigit: null,
            Bank: {
              Name: null
            }
          },
          SoftDescriptor: null,
          EndToEndId: null
        },
        Amount: null,
        PaymentDate: null,
        CreatedDate: null,
        CheckingAccounts: [],
        Splits: [],
        History: [],
        IsSplitter: false,
        Products: [],
        Plan: {
          Name: null
        },
        TransactionStatus: {
          Code: null
        }
      };
    },
    GetTransaction: function(id) {
      this.loadingTransaction = true;
      this.$store
        .dispatch("GetTransaction", { id: id, idMerchant: this.idMerchant })
        .then(response => {
          this.infoTransaction = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações da transação", error);
        })
        .finally(() => {
          this.loadingTransaction = false;
        });
    },
    HideModal: function() {
      this.$bvModal.hide("mFormTransaction");
    },
    ProcessNextStep: function(nextStep = null) {
      if (this.isSeeing) {
        if (nextStep != null) this.mCurrentStep = nextStep;
        else this.NextStep();
        return;
      }
    },
    NextStep: function() {
      if (this.mCurrentStep < this.mSteps.length - 1) {
        if (this.mCurrentStep == 3 && (this.infoTransaction.Splits == null || this.infoTransaction.Splits.length < 1)) {
          this.mCurrentStep += 2;
        } else this.mCurrentStep += 1;
      }
    },
    BackStep: function() {
      if (this.mCurrentStep >= 1) {
        if (this.mCurrentStep == 5 && (this.infoTransaction.Splits == null || this.infoTransaction.Splits.length < 1)) {
          this.mCurrentStep -= 2;
        } else this.mCurrentStep -= 1;
      }
    },
    GoToStep: function(e, stepToGo) {
      e.preventDefault();

      if (stepToGo <= this.mSteps.length && stepToGo >= 0) {
        if (stepToGo < this.mCurrentStep) {
          this.mCurrentStep = stepToGo;
        } else {
          this.ProcessNextStep(stepToGo);
        }
      }
    },
    ListTransactionStatus: function() {
      this.$store
        .dispatch("ListTransactionStatus", {})
        .then(response => {
          this.transactionStatus = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro carregar a lista de status", error);
        });
    },
    ListPaymentMethod: function() {
      this.$store
        .dispatch("ListPaymentMethod")
        .then(response => {
          this.paymentMethods = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de tipos de pagamento", error);
        });
    },
    ListApplications: function(idMerchant) {
      this.$store
        .dispatch("ListTransactionApplication", { idMerchant: idMerchant })
        .then(response => {
          this.applications = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de aplicações", error);
        });
    },
    ListVendors: function(idMerchant) {
      this.$store
        .dispatch("ListVendors", { idMerchant: idMerchant })
        .then(response => {
          this.vendors = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de vendedores", error);
        });
    },

    ResetFilter: function() {
      this.filter = {
        Id: null,
        CustomerName: null,
        CustomerIdentity: null,
        Reference: null,
        PaymentMethodCode: null,
        AmountInitial: null,
        AmountEnd: null,
        Vendor: null,
        Application: null,
        TransactionStatusCode: null,
        cancelAnimationFrame: null,
        CreatedDateInitial: null,
        CreatedDateEnd: null,
        PaymentDateInitial: null,
        PaymentDateEnd: null,
        IdMerchantSubAccount: null,
        IdTransactionSplitter: null,
        IsSandbox: false,
        IdCanal: null
      };
      this.ListTransaction(this.idMerchant);
    },
    previousPage: function() {
      const qs = require("qs");
      const prev = qs.parse(this.previousPageinfo);
      const component = prev.component;
      delete prev.component;

      this.$router.push({
        name: component,
        query: {
          previous: qs.stringify(prev)
        }
      });
    },
    GetReport: function(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(this.idMerchant, true);
      this.$store
        .dispatch("ReportTransaction", { params: data })
        .then(response => {
          if (response.UrlReport != null && response.UrlReport != undefined && response.UrlReport != "") {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    ComputeExpirationPix(CreatedDate, Expiration){
      const expirationDate = new Date(CreatedDate);
      expirationDate.setSeconds(expirationDate.getSeconds() + Expiration);
      return expirationDate;
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/MerchantTransaction/MerchantTransaction.js